<template>
  <div class="app-order-mnp-wrapper">
    <slot name="txtBefore"></slot>
    <b-form-checkbox
      id="order-mnp-checkbox"
      v-model="mnpData_.active"
      name="order-mnp-checkbox"
    >
      <slot name="mnpCheckbox">Rufnummer mitnehmen und 25 € Bonus-Guthaben sichern!</slot>
    </b-form-checkbox>
    <EnterMnpInData
      v-if="mnpData_.active"
      :mnp-providers="mnpProviders"
      :mnp-data.sync="mnpData_"
      :invalid.sync="mnpInvalid_"
    >
      <template v-for="slot in possibleChildSlotsFor('In')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </EnterMnpInData>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'
import EnterMnpInData from '@/components/process/FYVE/Order/Options/EnterMnpInData.vue'
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'EnterOptionsMnpData',
  data () {
    return {
      mnp: false
    }
  },
  components: { EnterMnpInData },
  mixins: [
    slotProxy(),
    syncProperty('mnpData', 'mnpData_'),
    syncProperty('mnpInvalid', 'mnpInvalid_')
  ],
  props: {
    mnpProviders: {
      type: Array,
      default: () => []
    }
  }
}
</script>
